import { createRoutine } from 'redux-saga-routines';

export const fetchComments = createRoutine('FETCH_COMMENTS');
export const addComment = createRoutine('ADD_COMMENT');
export const updateComment = createRoutine('EDIT_COMMENT');
export const deleteComment = createRoutine('DELETE_COMMENT');
export const clearComments = createRoutine('CLEAR_COMMENTS');
export const loadMoreComments = createRoutine('MORE_COMMENTS');
